module.exports = new __parcel__URL__("promos_base2024_3_2_video.a5ea18fd.mp4").toString();